<template>
  <div v-if="showSign" class="sign-dialog" @click="hideSigns">
    <div class="dialog-cont">
        <img class="close" :src="ossUrl+ '/dialogclose.png'" @click="hideSigns">
        <div class="dialog-top" :style="{backgroundImage: 'url('+ossUrl+'/dialogbg.jpg)'}">
        <div v-if="title != ''">
            <img class="taps" :src="ossUrl+'/jydp.png'">
            <span>{{title}}</span>
        </div>
        </div>
        <div class="signs">
        <slot/>
        </div>
    </div>
</div>
</template>
<script>
import { ossUrl } from "@/config";

export default {
    name: 'ModelDiv',
    props: {
      showSign: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: ''
      }
    },
    data() {
        return {
            ossUrl,
        }
    },
    methods: {
        hideSigns() {
          this.$emit('hide-signs', 0)
        }
    },
}
</script>
<style lang="scss" scoped>
.sign-dialog{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, .6);
  z-index: 1999;
}
.sign-dialog .signs {
  overflow-y: auto;
  height: 650px;
  margin: 30px auto 0;
  width: 90%;
  font-size: 28px;
  line-height: 42px;
  text-align: left;
}
.dialog-cont{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin:auto;
  width: 640px;
  height: 850px;
  background-color: #fff;
  padding-bottom: 20px;
  z-index: 99;
  border-radius: 6px;
}
.dialog-top{
  width: 100%;
  height: 200px;
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 6px 6px 0 0;
}
.dialog-top div{
   font-size: 32px;
   color: #fff;
   height: 50px;
   display: flex;
   justify-content: center;
   align-items: center;
   padding-top: 50px;
}
.dialog-top div img{
  margin-right: 20px;
}
.taps{
  width: 50px;
  height: 50px;
}
.dialog-cont .close{
  position: absolute;
  top: 20px;
  right: 0px;
  width: 35px;
  height: 35px;
  margin-right: 25px;
  margin-bottom: 25px;
}
.sign-dialog .signs img{
  width: 100%;
}
</style>